<assessment-row title="Mood">
  <emr-list [list]="data.mood" emptyText="N/A"></emr-list>
</assessment-row>

<assessment-row title="Suicidal Thoughts/Expression">
  <p>{{ isSuicidal }}</p>
</assessment-row>
